import { type Trello } from "../types/trello"
import { getShowRecentTimes, toggleRecentTimes } from "../storage"

export async function getCardButton(
  t: Trello.PowerUp.IFrame,
  props: any
): Promise<Trello.PowerUp.CardButton[]> {

  const showRecentTimes = await getShowRecentTimes(t)

  return [
    {
      icon: props.baseUrl + props.logo.light,
      text: "Add time",
      callback: (t: Trello.PowerUp.IFrame) => {
        return t.popup({
          title: "Add time",
          url: t.signUrl("./card-button.html"),
          height: 700,
        })
      }
    },
    {
      icon: props.baseUrl + (showRecentTimes ? props.hideIcon.dark : props.plusIcon.dark),
      text: showRecentTimes ? "Hide times" : "Show times",
      callback: (t: Trello.PowerUp.IFrame) => {
        return toggleRecentTimes(t) 
      }
    }
  ]
}
